import { FunctionalComponent, h } from 'preact';

import { chooseAOrB } from 'common/helper/choose/a-or-b';
import { i18nTranslate } from 'common/helper/i18n/translate';
import { PropertyPhoneNumberTemplatePropsInterface } from 'desktop/module/property-phone-number/template-props.interface';

export const PropertyPhoneNumberTemplate: FunctionalComponent<PropertyPhoneNumberTemplatePropsInterface> = (props) =>
  chooseAOrB(
    <span className='button__phone--ltr'>{props.phoneNumber}</span>,
    <span>{props.placeholder || i18nTranslate('Call')}</span>
  )(props.isPhoneNumberVisible);
